"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const molecules_1 = require("@components/molecules");
const _api_1 = __importDefault(require("@api"));
const _theme_1 = require("@theme");
var PaymentMethodDefaultForm = function PaymentMethodDefaultForm(_ref) {
    var paymentMethod = _ref.paymentMethod, refreshPaymentMethods = _ref.refreshPaymentMethods, dismissModal = _ref.dismissModal;
    if (!paymentMethod)
        return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null);
    var setDefaultPaymentMethod = function setDefaultPaymentMethod(id) {
        _api_1.default('setDefaultPaymentMethod', {
            id: id
        }).then(function () {
            refreshPaymentMethods();
            dismissModal();
        });
    };
    return /*#__PURE__*/ react_1.default.createElement(molecules_1.ConfirmationModal, {
        title: "Set default card",
        message: "Do you want to make this your default payment method?",
        dismiss: function dismiss() {
            return dismissModal();
        },
        actionLabel: "Set Default",
        action: function action() {
            return setDefaultPaymentMethod(paymentMethod.id);
        },
        actionColor: _theme_1.palette.green
    });
}; // Typing
exports.default = PaymentMethodDefaultForm;
